import React, { Fragment, useState } from "react";
import Content from "../common/Content";
import JobOfferTile from "../common/JobOfferTile";
import { ApiResult } from "../../lib/CmsApi";
import IntroHeader from "../IntroHeader";
import Grid from "../common/Grid";
import Contacts from "../sections/Contacts";
import Section from "../sections/Section";
import { sortByPositionField } from "../../lib/sort";
import styled from "styled-components";
import Button from "../common/Button";
import { spacing } from "../theme";
const StyledSection = styled(Section)`
  position: relative;
  z-index: 3;
`;
const StyledButton = styled(Button)`
  transition: all 0.5s;
  ${spacing("margin-top", 80)}
`;
export type Props = ApiResult<"loadJobCategoryBySlug"> & {
  careerPage: ApiResult<"loadCareer">;
};
export default function CareerLevelPage(props: Props) {
  const [isCollapsed, setCollapsed] = useState(true);
  return (
    <Fragment>
      <IntroHeader
        headline={props.headline}
        {...props.subheader}
        breadCrumpPath={[
          {
            title: "Karriere",
            route: "career"
          },
          {
            title: props.name,
            route: "careerLevel",
            params: {
              slug: props.slug
            }
          }
        ]}
      />
      <main>
        {props.jobs && props.jobs.length > 0 && (
          <StyledSection noTopPadding>
            <Content padded>
              <Grid
                columns={3}
                tabletColumns={2}
                mobileColumns={1}
                aria-expanded={!isCollapsed}
                id="program_grid"
              >
                {sortByPositionField(props.jobs)
                  .slice(0, isCollapsed ? 6 : props.jobs.length)
                  .map(job => {
                    return (
                      <JobOfferTile
                        alwaysShowIntro
                        headlineLevel={2}
                        key={job.slug}
                        {...job}
                        category={{ slug: props.slug, name: props.name }}
                      />
                    );
                  })}
              </Grid>
              {props.jobs && props.jobs.length > 6 && (
                <StyledButton
                  alignCenter
                  ghost
                  collapseStyle
                  collapsed={isCollapsed}
                  onclick={() => setCollapsed(!isCollapsed)}
                  aria-controls={"program_grid"}
                  aria-label={
                    isCollapsed
                      ? "Alle Stellen anzeigen"
                      : "Weniger Stellen anzeigen"
                  }
                >
                  {isCollapsed ? "Alle anzeigen" : "Weniger anzeigen"}
                </StyledButton>
              )}
            </Content>
          </StyledSection>
        )}
      </main>
      <aside>
        <Contacts
          headline="Wir sind für Sie da."
          copy={`Unsere Ansprechpartner für den Bereich „${
            props.careerPage.name
          }“ stehen Ihnen gerne für Ihre Anliegen zur Verfügung.`}
          withImage
          contacts={props.careerPage.contacts}
          ariaLabel={`Ansprechpartner für den Bereich ${props.careerPage.name}`}
        />
      </aside>
    </Fragment>
  );
}

CareerLevelPage.getImages = (props: Props) => {
  let images = [];
  images = images.concat(IntroHeader.getImages(props.subheader));
  images = images.concat(
    Contacts.getImages({
      contacts: props.careerPage.contacts,
      withImage: true
    })
  );
  return images;
};
